/*
 * This config is passed from bootstrap.
 */
export interface BootstrapConfig {
  bootstrapURL: string;
  creator?: string;
  locale: string;
  sessionId: string;
  token: string;
  userId?: string;
  fullSentryTracing?: boolean;
  stateGetRetry?: boolean;
  externalAddressBookProvider?: string;
  customStylesheetPath?: string;
}

export function encodeBootstrapConfig(config: BootstrapConfig) {
  return encodeURIComponent(JSON.stringify(config));
}

export function getBootstrapConfig(): BootstrapConfig {
  const url = new URL(window.location.href);
  const hashPart = url.hash.substring(1);
  return JSON.parse(decodeURIComponent(hashPart));
}
